export const SignUpTranslation = {
  pageTitle: 'SignUp.pageTitle',
  pageSubTitle: 'SignUp.pageSubTitle',
  pageWysiwyg: 'SignUp.pageWysiwyg',
  infoList: {
    title: 'SignUp.infoList.title',
    phone: 'SignUp.infoList.phone',
    group: 'SignUp.infoList.group',
    existingAccount: 'SignUp.infoList.existingAccount',
  },
  form: {
    title: 'SignUp.form.title',
    data: {
      name: {
        label: 'SignUp.form.data.name.label',
        placeholder: 'SignUp.form.data.name.placeholder',
      },
      surname1: {
        label: 'SignUp.form.data.surname1.label',
        placeholder: 'SignUp.form.data.surname1.placeholder',
      },
      surname2: {
        label: 'SignUp.form.data.surname2.label',
        placeholder: 'SignUp.form.data.surname2.placeholder',
      },
      phone: {
        label: 'SignUp.form.data.phone.label',
        placeholder: 'SignUp.form.data.phone.placeholder',
        legend: 'SignUp.form.data.phone.legend',
      },
      whatsappConsent: {
        labelBefore: 'SignUp.form.data.whatsappConsent.labelBefore',
        labelAfter: 'SignUp.form.data.whatsappConsent.labelAfter',
      },
      username: {
        label: 'SignUp.form.data.username.label',
        placeholder: 'SignUp.form.data.username.placeholder',
        legend: 'SignUp.form.data.username.legend',
      },
      email: {
        label: 'SignUp.form.data.email.label',
        placeholder: 'SignUp.form.data.email.placeholder',
        legend: 'SignUp.form.data.email.legend',
      },
      repeatEmail: {
        label: 'SignUp.form.data.repeatEmail.label',
        placeholder: 'SignUp.form.data.repeatEmail.placeholder',
      },
      password: {
        label: 'SignUp.form.data.password.label',
        placeholder: 'SignUp.form.data.password.placeholder',
        legend: 'SignUp.form.data.password.legend',
      },
      repeatPassword: {
        label: 'SignUp.form.data.repeatPassword.label',
        placeholder: 'SignUp.form.data.repeatPassword.placeholder',
      },
      acceptConditions: {
        label: 'SignUp.form.data.acceptConditions.label',
        link: 'SignUp.form.data.acceptConditions.link',
        href: 'SignUp.form.data.acceptConditions.href',
        filename: 'SignUp.form.data.acceptConditions.filename',
      },
    },
  },
  otp: {
    title: 'SignUp.otp.title',
    subtitle: 'SignUp.otp.subtitle',
    subtitle2: 'SignUp.otp.subtitle2',
    tel: 'SignUp.otp.tel',
    emailContact: 'SignUp.otp.emailContact',
    code: {
      placeholder: 'SignUp.otp.code.placeholder',
    },
    resend: 'SignUp.otp.resend',
    submit: 'SignUp.otp.submit',
    notificationSent: 'SignUp.otp.notificationSent',
    error: 'SignUp.otp.error',
  },
}

export const AutoEnrollmentTranslation = {
  pageTitle: 'AutoEnrollment.pageTitle',
  introduction: 'AutoEnrollment.introduction',
  premiumLegend: 'AutoEnrollment.premium.legend',
  titleServices: 'AutoEnrollment.premium.titleServices',
  titleDescription: 'AutoEnrollment.premium.titleDescription',
  titleParticipation: 'AutoEnrollment.premium.titleParticipation',
  stepper: {
    step1: 'AutoEnrollment.stepper.step1',
    step2: 'AutoEnrollment.stepper.step2',
    step3: 'AutoEnrollment.stepper.step3',
    step4: 'AutoEnrollment.stepper.step4',
    step5: 'AutoEnrollment.stepper.step5',
  },
  billingGeneralData: {
    title: 'AutoEnrollment.billingGeneralData.title',
    description: 'AutoEnrollment.billingGeneralData.description',
    data: {
      cif: {
        label: 'AutoEnrollment.billingGeneralData.data.cif.label',
        placeholder: 'AutoEnrollment.billingGeneralData.data.cif.placeholder',
        tooltip: 'AutoEnrollment.billingGeneralData.data.cif.tooltip',
        alreadyExistsError:
          'AutoEnrollment.billingGeneralData.data.cif.alreadyExistsError',
        warningError: 'AutoEnrollment.billingGeneralData.data.cif.warningMessage',
      },
      businessName: {
        label: 'AutoEnrollment.billingGeneralData.data.businessName.label',
        placeholder: 'AutoEnrollment.billingGeneralData.data.businessName.placeholder',
        tooltip: 'AutoEnrollment.billingGeneralData.data.businessName.tooltip',
      },
      documentType: {
        label: 'AutoEnrollment.billingGeneralData.data.documentType.label',
        placeholder: 'AutoEnrollment.billingGeneralData.data.documentType.placeholder',
        legend: 'AutoEnrollment.billingGeneralData.data.documentType.legend',
      },
      documentNumber: {
        label: 'AutoEnrollment.billingGeneralData.data.documentNumber.label',
        placeholder: 'AutoEnrollment.billingGeneralData.data.documentNumber.placeholder',
      },
    },
  },
  billingAddressData: {
    title: 'AutoEnrollment.billingAddressData.title',
    description: 'AutoEnrollment.billingAddressData.description',
    data: {
      street: {
        label: 'AutoEnrollment.billingAddressData.data.street.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.street.placeholder',
        tooltip: 'AutoEnrollment.billingAddressData.data.street.tooltip',
      },
      number: {
        label: 'AutoEnrollment.billingAddressData.data.number.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.number.placeholder',
      },
      additionalInfo: {
        label: 'AutoEnrollment.billingAddressData.data.additionalInfo.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.additionalInfo.placeholder',
      },
      floorBlockStair: {
        label: 'AutoEnrollment.billingAddressData.data.floorBlockStair.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.floorBlockStair.placeholder',
      },
      postalCode: {
        label: 'AutoEnrollment.billingAddressData.data.postalCode.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.postalCode.placeholder',
      },
      city: {
        label: 'AutoEnrollment.billingAddressData.data.city.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.city.placeholder',
      },
      province: {
        label: 'AutoEnrollment.billingAddressData.data.province.label',
        placeholder: 'AutoEnrollment.billingAddressData.data.province.placeholder',
      },
    },
  },
  billingOwnerData: {
    title: 'AutoEnrollment.billingOwnerData.title',
    description: 'AutoEnrollment.billingOwnerData.description',
    data: {
      name: {
        label: 'AutoEnrollment.billingOwnerData.data.name.label',
        placeholder: 'AutoEnrollment.billingOwnerData.data.name.placeholder',
      },
      surname1: {
        label: 'AutoEnrollment.billingOwnerData.data.surname1.label',
        placeholder: 'AutoEnrollment.billingOwnerData.data.surname1.placeholder',
      },
      surname2: {
        label: 'AutoEnrollment.billingOwnerData.data.surname2.label',
        placeholder: 'AutoEnrollment.billingOwnerData.data.surname2.placeholder',
      },
      email: {
        label: 'AutoEnrollment.billingOwnerData.data.email.label',
        placeholder: 'AutoEnrollment.billingOwnerData.data.email.placeholder',
        tooltip: 'AutoEnrollment.billingOwnerData.data.email.tooltip',
      },
      phone: {
        label: 'AutoEnrollment.billingOwnerData.data.phone.label',
        placeholder: 'AutoEnrollment.billingOwnerData.data.phone.placeholder',
        tooltip: 'AutoEnrollment.billingOwnerData.data.phone.tooltip',
        mobile: {
          label: 'AutoEnrollment.billingOwnerData.data.phone.mobile.label',
        },
      },
    },
  },
  paymentAccountData: {
    title: 'AutoEnrollment.paymentAccountData.title',
    description: 'AutoEnrollment.paymentAccountData.description',
    data: {
      iban: {
        label: 'AutoEnrollment.paymentAccountData.data.iban.label',
        placeholder: 'AutoEnrollment.paymentAccountData.data.iban.placeholder',
      },
    },
  },
  paymentContactData: {
    title: 'AutoEnrollment.paymentContactData.title',
    description: 'AutoEnrollment.paymentContactData.description',
    fillWithOwnerData: 'AutoEnrollment.paymentContactData.fillWithOwnerData',
    data: {
      name: {
        label: 'AutoEnrollment.paymentContactData.data.name.label',
        placeholder: 'AutoEnrollment.paymentContactData.data.name.placeholder',
      },
      surname1: {
        label: 'AutoEnrollment.paymentContactData.data.surname1.label',
        placeholder: 'AutoEnrollment.paymentContactData.data.surname1.placeholder',
      },
      surname2: {
        label: 'AutoEnrollment.paymentContactData.data.surname2.label',
        placeholder: 'AutoEnrollment.paymentContactData.data.surname2.placeholder',
      },
      email: {
        label: 'AutoEnrollment.paymentContactData.data.email.label',
        placeholder: 'AutoEnrollment.paymentContactData.data.email.placeholder',
      },
      phone: {
        label: 'AutoEnrollment.paymentContactData.data.phone.label',
        placeholder: 'AutoEnrollment.paymentContactData.data.phone.placeholder',
      },
    },
  },
  storeGeneralData: {
    title: 'AutoEnrollment.storeGeneralData.title',
    description: 'AutoEnrollment.storeGeneralData.description',
    data: {
      storeName: {
        label: 'AutoEnrollment.storeGeneralData.data.storeName.label',
        placeholder: 'AutoEnrollment.storeGeneralData.data.storeName.placeholder',
        tooltip: 'AutoEnrollment.storeGeneralData.data.storeName.tooltip',
      },
      storeEmail: {
        label: 'AutoEnrollment.storeGeneralData.data.storeEmail.label',
        placeholder: 'AutoEnrollment.storeGeneralData.data.storeEmail.placeholder',
      },
      storePhone: {
        label: 'AutoEnrollment.storeGeneralData.data.storePhone.label',
        placeholder: 'AutoEnrollment.storeGeneralData.data.storePhone.placeholder',
        tooltip: 'AutoEnrollment.storeGeneralData.data.storePhone.tooltip',
      },
      storeWeb: {
        label: 'AutoEnrollment.storeGeneralData.data.storeWeb.label',
        placeholder: 'AutoEnrollment.storeGeneralData.data.storeWeb.placeholder',
        tooltip: 'AutoEnrollment.storeGeneralData.data.storeWeb.tooltip',
        legend: 'AutoEnrollment.storeGeneralData.data.storeWeb.legend',
      },
      foodType: {
        label: 'AutoEnrollment.storeGeneralData.data.foodType.label',
        placeholder: 'AutoEnrollment.storeGeneralData.data.foodType.placeholder',
        tooltip: 'AutoEnrollment.storeGeneralData.data.foodType.tooltip',
      },
      service: {
        label: 'AutoEnrollment.storeGeneralData.data.service.label',
        error: 'AutoEnrollment.storeGeneralData.data.service.error',
        types: {
          physical: 'AutoEnrollment.storeGeneralData.data.service.types.physical',
          delivery: 'AutoEnrollment.storeGeneralData.data.service.types.delivery',
          takeAway: 'AutoEnrollment.storeGeneralData.data.service.types.takeAway',
        },
      },
    },
  },
  storeAddressData: {
    title: 'AutoEnrollment.storeAddressData.title',
    description: 'AutoEnrollment.storeAddressData.description',
    warning: 'AutoEnrollment.storeAddressData.warning',
    noPlacesError: 'AutoEnrollment.storeAddressData.noPlacesError',
    data: {
      street: {
        label: 'AutoEnrollment.storeAddressData.data.street.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.street.placeholder',
        tooltip: 'AutoEnrollment.storeAddressData.data.street.tooltip',
      },
      number: {
        label: 'AutoEnrollment.storeAddressData.data.number.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.number.placeholder',
      },
      floorBlockStair: {
        label: 'AutoEnrollment.storeAddressData.data.floorBlockStair.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.floorBlockStair.placeholder',
      },
      postalCode: {
        label: 'AutoEnrollment.storeAddressData.data.postalCode.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.postalCode.placeholder',
      },
      city: {
        label: 'AutoEnrollment.storeAddressData.data.city.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.city.placeholder',
      },
      province: {
        label: 'AutoEnrollment.storeAddressData.data.province.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.province.placeholder',
      },
      additionalInfo: {
        label: 'AutoEnrollment.storeAddressData.data.additionalInfo.label',
        placeholder: 'AutoEnrollment.storeAddressData.data.additionalInfo.placeholder',
      },
    },
  },
  storeContactData: {
    title: 'AutoEnrollment.storeContactData.title',
    description: 'AutoEnrollment.storeContactData.description',
    fillWithOwnerData: 'AutoEnrollment.storeContactData.fillWithOwnerData',
    data: {
      name: {
        label: 'AutoEnrollment.storeContactData.data.name.label',
        placeholder: 'AutoEnrollment.storeContactData.data.name.placeholder',
      },
      surname1: {
        label: 'AutoEnrollment.storeContactData.data.surname1.label',
        placeholder: 'AutoEnrollment.storeContactData.data.surname1.placeholder',
      },
      surname2: {
        label: 'AutoEnrollment.storeContactData.data.surname2.label',
        placeholder: 'AutoEnrollment.storeContactData.data.surname2.placeholder',
      },
      email: {
        label: 'AutoEnrollment.storeContactData.data.email.label',
        placeholder: 'AutoEnrollment.storeContactData.data.email.placeholder',
      },
      phone: {
        label: 'AutoEnrollment.storeContactData.data.phone.label',
        placeholder: 'AutoEnrollment.storeContactData.data.phone.placeholder',
      },
    },
  },
  storeTpvsData: {
    title: 'AutoEnrollment.storeTpvsData.title',
    description: 'AutoEnrollment.storeTpvsData.description',
    guide: {
      description: 'AutoEnrollment.storeTpvsData.guide.description',
    },
    tpvs: {
      label: 'AutoEnrollment.storeTpvsData.tpvs.label',
      placeHolder: 'AutoEnrollment.storeTpvsData.tpvs.placeHolder',
      add: 'AutoEnrollment.storeTpvsData.tpvs.add',
      delete: 'AutoEnrollment.storeTpvsData.tpvs.delete',
    },
  },
  storeWelcomePackData: {
    title: 'AutoEnrollment.storeWelcomePackData.title',
    description: 'AutoEnrollment.storeWelcomePackData.description',
    data: {
      useStoreAddress: {
        label: 'AutoEnrollment.storeWelcomePackData.data.useStoreAddress.label',
        helpText: 'AutoEnrollment.storeWelcomePackData.data.useStoreAddress.helpText',
      },
      useBillingAddress: {
        label: 'AutoEnrollment.storeWelcomePackData.data.useBillingAddress.label',
        helpText: 'AutoEnrollment.storeWelcomePackData.data.useBillingAddress.helpText',
      },
      address: 'AutoEnrollment.storeWelcomePackData.data.address',
    },
  },
  productsConditions: {
    title: 'AutoEnrollment.productsConditions.title',
    description: 'AutoEnrollment.productsConditions.description',
    contractable: {
      title: 'AutoEnrollment.productsConditions.contractable.title',
      subtitle: 'AutoEnrollment.productsConditions.contractable.subtitle',
      Wysiwyg: 'AutoEnrollment.productsConditions.contractable.Wysiwyg',
      Wysiwyg2: 'AutoEnrollment.productsConditions.contractable.Wysiwyg2',
    },
    contractableSwitch: {
      true: 'AutoEnrollment.productsConditions.contractableSwitch.true',
      false: 'AutoEnrollment.productsConditions.contractableSwitch.false',
    },
    servicesTable: {
      title: 'AutoEnrollment.productsConditions.servicesTable.title',
      disclaimer: {
        19: 'AutoEnrollment.productsConditions.servicesTable.disclaimer.19',
        33: 'AutoEnrollment.productsConditions.servicesTable.disclaimer.33',
        7: '',
        16: '',
        23: '',
        24: '',
        98: '',
        99: '',
      },
      conditions: {
        2: 'AutoEnrollment.productsConditions.servicesTable.conditions.2',
        7: 'AutoEnrollment.productsConditions.servicesTable.conditions.7',
        8: 'AutoEnrollment.productsConditions.servicesTable.conditions.8',
      },
      downloadButton: {
        label: 'AutoEnrollment.productsConditions.servicesTable.downloadButton.label',
      },
    },
    subProductsTable: {
      title: 'AutoEnrollment.productsConditions.subProductsTable.title',
      description: 'AutoEnrollment.productsConditions.subProductsTable.description',
    },
    signDocuments: {
      title: 'AutoEnrollment.productsConditions.signDocuments.title',
      description: 'AutoEnrollment.productsConditions.signDocuments.description',
      acceptIAE: {
        label: 'AutoEnrollment.productsConditions.signDocuments.acceptIAE.label',
        error: 'AutoEnrollment.productsConditions.signDocuments.acceptIAE.error',
      },
      signButton: {
        label: 'AutoEnrollment.productsConditions.signDocuments.signButton.label',
        disabled: 'AutoEnrollment.productsConditions.signDocuments.signButton.disabled',
      },
      signBlock: {
        label: 'AutoEnrollment.productsConditions.signDocuments.signBlock.label',
      },
    },
  },
  confirmationScreen: {
    pending: {
      description: 'AutoEnrollment.confirmationScreen.pending.description',
    },
    success: {
      title: 'AutoEnrollment.confirmationScreen.success.title',
      description: 'AutoEnrollment.confirmationScreen.success.description',
      button: {
        label: 'AutoEnrollment.confirmationScreen.success.button.label',
      },
    },
    error: {
      title: 'AutoEnrollment.confirmationScreen.error.title',
      description: 'AutoEnrollment.confirmationScreen.error.description',
      description2: 'AutoEnrollment.confirmationScreen.error.description2',
      supportEmail: 'AutoEnrollment.confirmationScreen.error.supportEmail',
      description3: 'AutoEnrollment.confirmationScreen.error.description3',
      button: {
        label: 'AutoEnrollment.confirmationScreen.error.button.label',
      },
    },
  },
}

export const CashbackAutoEnrollmentTranslation = {
  pageTitle: 'CashbackAutoEnrollment.pageTitle',
  instructions: 'CashbackAutoEnrollment.instructions',
  instructions2: 'CashbackAutoEnrollment.instructions2',
  button: {
    continue: 'CashbackAutoEnrollment.button.continue',
  },
}
